/**
 * An alarm centre's "Kommunikationsspråk" (communication_language): the language of the
 * mails sent to it, such as the alarm documentation. Alarm centres saved before the field
 * existed have none and are mailed in their country's language (the portal they were
 * created on) - which is also what the form shows for them until it is saved.
 * See securecloud-server utils/alarm-center-language.js.
 */
import { isNorwegianSite } from "@/utils/siteContext";

export function communicationLanguageOptions(t) {
  return ["sv", "en", "no", "nl"].map((id) => ({ id, name: t(`communication_language.${id}`) }));
}

/** The language this alarm centre is mailed in: its own, else its country's (else the portal's). */
export function communicationLanguageOf(alarmCenter) {
  if (alarmCenter && alarmCenter.communication_language) return alarmCenter.communication_language;
  const country = (alarmCenter && alarmCenter.country) || (isNorwegianSite() ? "no" : "se");
  return country === "no" ? "no" : "sv";
}
